import { FC, PropsWithChildren, ReactNode } from 'react'
import { useBoolean } from 'ahooks'

import { Button } from '@trustycars/genie-ui/components'

import ExtraIcon from '$icons/ExtraIcon'

import {
  container,
  header,
  description as descriptionStyle,
  title as titleStyle,
  footer,
  badge,
  skipBtn
} from './styles.css'

export type InfoProps = {
  required?: boolean
  title: string
  description?: ReactNode
  onSkip: VoidFunction
  continueBtnText?: string
}

export const Info: FC<PropsWithChildren<InfoProps>> = ({
  required,
  title,
  description,
  onSkip,
  continueBtnText = 'Continue',
  children
}) => {
  const [isContinue, { setTrue }] = useBoolean(false)

  if (isContinue) return children

  return (
    <section className={container}>
      <header className={header}>
        <div>
          <figure className={badge}>
            <ExtraIcon name="alert-triangle" />
          </figure>
        </div>
      </header>

      <main>
        <h2 className={titleStyle}>{title}</h2>

        {description && <p className={descriptionStyle}>{description}</p>}
      </main>

      <footer className={footer}>
        <button onClick={onSkip} className={skipBtn} disabled={required}>
          Skip For Now
        </button>

        <Button onClick={setTrue}>{continueBtnText}</Button>
      </footer>
    </section>
  )
}

export default Info
